<template>
  <div class="super-admin-dashboard__dashboard-widget">
    <span class="super-admin-dashboard__dashboard-widget-content">
      <span class="super-admin-dashboard__dashboard-widget-content-title">
        {{ title }}
      </span>
      <img
        v-if="logo"
        alt="logo"
        class="super-admin-dashboard__dashboard-widget-content-logo"
        :src="logo"
      />
      <span
        v-if="subtitle"
        class="super-admin-dashboard__dashboard-widget-content-subtitle"
      >
        {{ subtitle }}
      </span>
      <div class="super-admin-dashboard__dashboard-widget-stats">
        <slot />
      </div>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    logo: {
      type: String,
      default: null
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: null
    }
  }
}
</script>
